import React from "react";
import styled from "styled-components";
import CheckIcon from "../assets/images/icon-check.svg";
import CrossIcon from "../assets/images/icon-cross.svg";

const Container = styled.li`
  width: 100%;
  /* height: 37px; */
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid ${(props) => props.theme["clr-gb-5"]};
  background-color: ${(props) => props.theme["clr-card-bg"]};

  &:first-child {
    border-radius: 0.5rem 0.5rem 0 0;
  }
`;

const Button = styled.button`
  width: 20px;
  height: 20px;
  border: 1.6px solid ${(props) => props.theme["clr-gb-5"]};
  background-color: transparent;
  border-radius: 50%;
  background-clip: padding-box;
  cursor: pointer;

  &.active {
    background-image: linear-gradient(
      45deg,
      hsl(192, 100%, 67%),
      hsl(280, 87%, 65%)
    );
  }
`;

const Icon = styled.img`
  width: 10px;
  height: 10px;
  cursor: pointer;
  user-select: none;
`;

const DeleteIconContainer = styled.div`
  width: 30px;
  height: 20px;

  &:hover {
    img {
      display: block;
      user-select: none;
    }
  }
`;

const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: none;
`;

const Item = styled.span`
  border: none;
  outline: none;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme["clr-gb-2"]};

  &.selected {
    color: hsl(234, 11%, 52%);
    text-decoration: line-through;
  }
`;

const ListItem = ({
  data,
  toggleCheckBox,
  deleteTask,
  draggableRef,
  draggableProps,
  dragHandleProps,
}) => {
  return (
    <Container ref={draggableRef} {...draggableProps} {...dragHandleProps}>
      <Button
        className={data.isCompleted && "active"}
        onClick={() => toggleCheckBox(data.id)}
      >
        {data.isCompleted ? <Icon src={CheckIcon} alt="" /> : null}
      </Button>
      <Item className={data.isCompleted && "selected"}>{data.text}</Item>
      <DeleteIconContainer>
        <DeleteIcon
          src={CrossIcon}
          alt=""
          onClick={() => deleteTask(data.id)}
        />
      </DeleteIconContainer>
    </Container>
  );
};

export default ListItem;
